import { z } from 'zod';
import { baseTemperatureRefined, baseO2Refined, baseRespirationRefined, basePulseRefined, baseBloodSugarRefined } from '../shared/vitals';
import { baseBloodPressureRefined } from '../oasis-sections/vitals';
import { basePainRefined } from '../shared/pain';
import { baseLastBowelMovementRefined } from '../shared/last-bowel-movement';
export const hhaVisitValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        General: z.object({
            precautions: z.array(z.string()).optional(),
        }),
        Vitals: z.object({
            bloodPressure: baseBloodPressureRefined,
            pulse: basePulseRefined,
            respiration: baseRespirationRefined,
            temperature: baseTemperatureRefined,
            o2: baseO2Refined,
            pain: basePainRefined,
            bloodSugar: baseBloodSugarRefined,
            bowelMovement: baseLastBowelMovementRefined,
        }),
        Bathing: z.object({
            bathing: z.object({
                requiresBathing: z.boolean().optional(),
                requires: z.string().optional(),
                bathType: z.string().optional(),
                bathTypeOther: z.string().optional(),
                entirety: z.string().optional(),
                safeLevel: z.string().optional(),
            }),
            dressing: z.string().optional(),
            dressingOther: z.string().optional(),
            availableEquipment: z.array(z.string()).optional(),
            availableEquipmentOther: z.string().optional(),
        }),
        PersonalCare: z.object({
            personalCare: z.object({
                requiresPersonalCare: z.boolean().optional(),
                requires: z.string().nullish(),
            }),
            hair: z.array(z.string()).optional(),
            teeth: z.array(z.string()).optional(),
            other: z.object({
                other: z.array(z.string()).optional(),
                skinCareSpecify: z.string().nullish(),
                compressionHose: z.boolean().optional(),
            }),
            pressureArea: z.object({
                findings: z.string().optional(),
                noneObserved: z.boolean().optional(),
            }),
        }),
        Ambulation: z.object({
            ambulation: z.object({
                requiresAmbulation: z.boolean().optional(),
                requires: z.string().optional(),
            }),
            device: z.object({
                devices: z.array(z.string()).optional(),
                other: z.string().nullish(),
            }),
            weightBearing: z.object({
                weightBearing: z.array(z.string()).optional(),
                partialLeg: z.array(z.string()).optional(),
                nonLeg: z.array(z.string()).optional(),
            }),
            requiredAssistance: z.object({
                transfers: z.string().optional(),
                other: z.string().nullish(),
            }),
        }),
        Other: z.object({
            other: z.object({
                otherOptions: z.array(z.string()).optional(),
                catheterDrainage: z.boolean().optional(),
                assistedWithMedications: z.string().optional(),
                ostomyCare: z.string().optional(),
            }),
            rom: z.array(z.string()).optional(),
            prepare: z.array(z.string()).optional(),
            changedBedLinens: z.object({
                frequency: z.array(z.string()).optional(),
                frequencyOther: z.string().nullish(),
            }),
            lastBowelMovement: z.string().optional(),
        }),
        Reported: z.object({
            employeeName: z.string().optional(),
            date: z.string().optional(),
            reportedItems: z.array(z.string()).optional(),
            patientComplaining: z.string().optional(),
            other: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
